import { WHATSAPP_CHANNEL } from 'src/constants/conversations';
import { getChannelStrategy } from './strategies';
import { TResolveChannelParams, TResolvedChannel } from './types';

/**
 * Resolves what can be sent on a conversation given its channel and the store area config.
 * Without a conversation the channel is WhatsApp: a template can start one.
 *
 * @param params.conversation - Conversation (or null when the lead has none)
 * @param params.store - Store with its areas
 * @param params.areaName - Area to use when the conversation has none
 * @param params.now - Current date, injectable for the 24 h session window
 */
export const resolveConversationChannel = ({
    conversation,
    store,
    areaName,
    now,
}: TResolveChannelParams): TResolvedChannel => {
    const channel = conversation?.channel || WHATSAPP_CHANNEL;
    const name = conversation?.area || areaName;
    const area = store?.areas?.find((item) => item.name === name) || null;

    return getChannelStrategy(channel).resolve({
        conversation,
        store,
        areaName: name,
        area,
        now,
    });
};
